/**
 * Recorte de instrumentos por estrutura (Barragem A/B/C) — GUPM-134.
 * TS puro, testável sem mock. Regra de arquitetura: sem React/Supabase/DOM.
 */
import type { Instrument } from '@/domain';

/** Sentinela de "todas as estruturas" (sem recorte). */
export const ALL_DAMS = 'all' as const;

/** Seleção do filtro: um `damId` (uuid) ou `'all'` (todas). */
export type DamSelection = string | typeof ALL_DAMS;

/** Recorta os instrumentos pela barragem selecionada (por `damId`). `'all'` = tudo. */
export function filterInstrumentsByDam(
  instruments: Instrument[],
  selection: DamSelection,
): Instrument[] {
  if (selection === ALL_DAMS) return instruments;
  return instruments.filter((inst) => inst.damId === selection);
}

/**
 * Conta instrumentos por barragem. Semeia `0` para cada id em `damIds` — a chave
 * sempre existe, então a pill mostra `(0)` para barragem vazia (não some).
 */
export function countInstrumentsByDam(
  instruments: Instrument[],
  damIds: readonly string[],
): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const id of damIds) counts[id] = 0;
  for (const inst of instruments) {
    if (inst.damId in counts) counts[inst.damId] = (counts[inst.damId] ?? 0) + 1;
  }
  return counts;
}
